<template>
  <offer-sale-base :offer-sale="offerSale" :is-activable="isActivable">
    <template v-slot:line-1>
      <offer-sale-line :line-items="productInfoItems" />
    </template>

    <template v-slot:line-2>
      <offer-sale-line :line-items="targetDiscount" />
    </template>
  </offer-sale-base>
</template>

<script>
import OfferSaleBase from './OfferSaleBase.vue'
import OfferSaleLine from './OfferSaleLine.vue'

export default {
  name: 'CrossSellOfferSaleTarget',
  components: {
    OfferSaleBase,
    OfferSaleLine,
  },
  props: {
    offerSale: {
      type: Object,
      required: true,
    },
    targetDiscount: {
      type: Number,
      required: true,
    },
    isActivable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    productInfoItems() {
      return [
        {
          label: 'SKU',
          value: this.offerSale.sku,
          format: 'text',
        },
        {
          label: 'EAN',
          value: this.offerSale.ean,
          format: 'text',
        },
      ]
    },
    discountItem() {
      return [
        {
          label: 'Desconto',
          value: this.targetDiscount,
          format: 'percent',
        },
      ]
    },
  },
}
</script>
